<bms-common-popup
  [icon]="'email'"
  [title]="'Email Preview'"
  [subTitle]="'Preview and edit the email before sending to the insurer'"
  [cancelTitle]="'shared.remarks-popup.cancel' | translate"
  [submitTitle]="'shared.remarks-popup.send' | translate"
  (onCancelClick)="onCancel()"
  (onSubmitClick)="onSave()"
  [isSubmitEnabled]="form.valid"
>
  <form [formGroup]="form" class="email-preview-form">
    <div class="subject-field-container">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Subject</mat-label>
        <input matInput formControlName="subject" placeholder="Enter email subject" />
        <mat-error *ngIf="form.get('subject').hasError('required')">
          Subject is required
        </mat-error>
      </mat-form-field>
    </div>

    <div class="email-card-scroll-wrapper">
      <div class="email-card-container">
        <div [innerHTML]="previewHtml" class="email-rendered-template"></div>
      </div>
    </div>
  </form>
</bms-common-popup>
